import styled from 'styled-components';
import { connect } from '@ardoq/rxbeach';
import { OptionsGroup } from '@ardoq/settings-bar';
import { WithPopover } from '@ardoq/popovers';
import { WithPointerEvents } from '@ardoq/style-helpers';
import { ButtonWithDropdown } from '@ardoq/dropdown-menu';
import { ButtonType } from '@ardoq/button';
import { DropdownSize } from '@ardoq/dropdown-menu-ui';
import { ExtractStreamShape } from 'tabview/types';
import { rightControls$ } from './rightControls$';
import { Box, FlexBox } from '@ardoq/layout';
import { ToolbarDivider } from '@ardoq/page-layout';
import { t } from '@ardoq/i18n';

// I have to use this clumsy last-child selector in order to style the split button's outer container.
const RightControlsFlexBox = styled(FlexBox)`
  > div:last-child {
    min-width: fit-content;
  }
`;

type ViewPaneHeaderRightControlsProperties = ExtractStreamShape<
  typeof rightControls$
>;

const ViewPaneHeaderRightControls = ({
  mainViewId,
  isSaveAsViewpointSidePanelOpened,
  saveAsViewpointButtonState,
  rightControlsLeftOptions,
  rightControlsRightOptions,
  saveButtonOptions,
  isFileExporting,
  i18nLocale,
}: ViewPaneHeaderRightControlsProperties) => (
  <RightControlsFlexBox gap="xsmall">
    <OptionsGroup
      viewId={mainViewId}
      isViewpointModeViewPaneHeader={true}
      options={rightControlsLeftOptions}
      i18nLocale={i18nLocale}
    />
    {saveButtonOptions.length > 0 && (
      <>
        <WithPopover content={saveAsViewpointButtonState.disabledDescription}>
          <WithPointerEvents>
            <ButtonWithDropdown
              buttonType={ButtonType.PRIMARY}
              dropdownSize={DropdownSize.S}
              isActive={isSaveAsViewpointSidePanelOpened}
              isLoading={isFileExporting}
              options={saveButtonOptions}
              dataTestId="save-as-options"
              aria-label={t(
                i18nLocale,
                'appLayout:viewPaneHeader.saveAsOptionsAriaLabel',
                'Save as options'
              )}
            >
              {t(i18nLocale, 'appLayout:saveAs', 'Save as')}
            </ButtonWithDropdown>
          </WithPointerEvents>
        </WithPopover>
        <Box paddingX="xsmall">
          <ToolbarDivider />
        </Box>
      </>
    )}
    <OptionsGroup
      viewId={mainViewId}
      isViewpointModeViewPaneHeader={true}
      options={rightControlsRightOptions}
      i18nLocale={i18nLocale}
    />
  </RightControlsFlexBox>
);

const ConnectedViewPaneHeaderRightControls = connect(
  ViewPaneHeaderRightControls,
  rightControls$
);
export { ConnectedViewPaneHeaderRightControls };
